import SignUpOrLogInButton from "components/Button/SignUpButton/SignUpOrLogInButton";
import useLabels from "hooks/useLabels";
import { CreditedFeature } from "store/slices/subscription";

type SignInProps = {
  feature: CreditedFeature;
  bottomRightComponent?: React.ReactNode;
  containerClassName: string;
};

/**
 * @component SignIn
 * @description Prompt to sign in when gated from using an AI-powered feature such as ask paper.
 */
function SignIn({
  feature,
  bottomRightComponent,
  containerClassName,
}: SignInProps) {
  const [signInLabels, featureLabels] = useLabels(
    "sign-in",
    `credits.features.${feature}`
  );

  return (
    <div className={containerClassName}>
      <h1 className="mb-2 base-md">
        {signInLabels["sign-up"].replace("{FEATURE}", featureLabels["title"])}
      </h1>
      <p className="sm-normal">
        {signInLabels["sign-up-description"].replace(
          "{FEATURE}",
          featureLabels["title"]
        )}
      </p>
      <div className="flex justify-between items-center mt-2.5">
        <SignUpOrLogInButton />
        {bottomRightComponent}
      </div>
    </div>
  );
}

export default SignIn;
